import {
  CButton,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";

import { EyeIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import { Link } from "react-router-dom";
import SessionModal from "../../components/modals/SessionsModal";
import { DriverProfileStatusDisplayValue } from "../../helpers/enums";
import { pluralize } from "../../helpers/general";
import { ProfilePictureAvatar } from "../../components/taxi/Profile_picture_avatar";

interface SimpleDriversTableProps {
  drivers: Driver[];
  sortBy: "default" | "sessionsCount";
  onSortChange?: (sortField: "default" | "sessionsCount") => void;
  date: string;
  range: string;
}

export default function SimpleDriversTable({
  drivers,
  sortBy,
  onSortChange = () => {},
  date,
  range,
}: SimpleDriversTableProps) {
  const [selectedDriverSessions, setSelectedDriverSessions] =
    useState<Driver | null>(null);

  const handleSortToggle = () => {
    const newSort = sortBy === "sessionsCount" ? "default" : "sessionsCount";
    onSortChange(newSort);
  };

  console.log(drivers);

  return (
    <>
      <CTable className="mt-4 p-2">
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col">Nom</CTableHeaderCell>
            <CTableHeaderCell scope="col">Statut</CTableHeaderCell>
            <CTableHeaderCell scope="col">
              Derniere connection{" "}
            </CTableHeaderCell>
            <CTableHeaderCell scope="col">
              <button
                title="Trier par nombre de connexions"
                className="border-0 bg-transparent fw-bold"
                onClick={handleSortToggle}
              >
                Sessions{" "}
                {sortBy === "sessionsCount" ? <span>▲</span> : <span>▼</span>}
              </button>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col">Actions</CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {drivers.map((driver) => {
            const Driverstatus =
              driver.status.toUpperCase() as keyof typeof DriverProfileStatusDisplayValue;

            return (
              <CTableRow key={driver.id}>
                <CTableDataCell className="px-3 text-sm">
                  <div className="d-flex align-items-center gap-3">
                    {/* <img
                      src={
                        driver.profilePicture ??
                        `https://ui-avatars.com/api/?name=${driver?.fullName}`
                      }
                      alt=""
                      width={30}
                      height={30}
                      style={{ borderRadius: "100%" }}
                    /> */}

                    <ProfilePictureAvatar
                      profilePicture={driver?.profilePicture}
                      fullName={driver?.fullName}
                      isOnline={driver?.isOnline}
                    />
                    <div>
                      <Link
                        to={`/drivers/${driver?.id}`}
                        className="fw-bold m-0"
                      >
                        {driver?.fullName}
                      </Link>
                      <p className="m-0">{driver.email}</p>
                    </div>
                  </div>
                </CTableDataCell>
                <CTableDataCell>
                  {DriverProfileStatusDisplayValue[Driverstatus]}
                </CTableDataCell>
                <CTableDataCell>
                  {driver.sessions?.length > 0
                    ? new Date(driver.sessions[0].createdAt).toLocaleDateString(
                        "fr-FR",
                      ) +
                      " " +
                      new Date(driver.sessions[0].createdAt).toLocaleTimeString(
                        "fr-FR",
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                        },
                      )
                    : "Aucune connexion"}
                </CTableDataCell>
                <CTableDataCell>
                  {driver.sessions?.length > 0
                    ? ` ${driver.sessions?.length}  ${pluralize(
                        "Session",
                        driver.sessions?.length,
                      )}`
                    : " Aucun login"}
                </CTableDataCell>
                <CTableDataCell>
                  {driver.sessions?.length > 0 ? ` 🟢 ` : " 🔴 "}
                  <CButton
                    color=""
                    size="sm"
                    onClick={() => setSelectedDriverSessions(driver)}
                  >
                    <EyeIcon width={16} height={16} />
                  </CButton>
                </CTableDataCell>
              </CTableRow>
            );
          })}
        </CTableBody>
      </CTable>

      {/* Modal */}
      {selectedDriverSessions && (
        <SessionModal
          driver={selectedDriverSessions}
          onClose={() => setSelectedDriverSessions(null)}
          date={date}
          range={range}
        />
      )}
    </>
  );
}
